// 设置Cookie
export function setCookie(value) {
  let str = window.location.host.split('.')[0] + '.'
  let domain = window.location.host.replace(str, '')
  console.log('domain', domain);
  let yw = ''
  let dl = ''
  let evnName = process.env.VUE_APP_ENV_NAME
  if (evnName === 'pro') {
    yw = 'rzTokenYw'
    dl = 'rzTokenDl'
  } else {
    yw = 'rzTokenTestYw'
    dl = 'rzTokenTestDl'
  }
  if (evnName === 'dev') {
    document.cookie = `${encodeURIComponent(yw)}=${encodeURIComponent(value)};path=/`;
    document.cookie = `${encodeURIComponent(dl)}=${encodeURIComponent(value)};path=/`;
  } else {
    document.cookie = `${encodeURIComponent(yw)}=${encodeURIComponent(value)};domain=${domain};path=/`;
    document.cookie = `${encodeURIComponent(dl)}=${encodeURIComponent(value)};domain=${domain};path=/`;
  }
}

export function getCookie() {
  let name = ''
  let evnName = process.env.VUE_APP_ENV_NAME
  if (evnName === 'pro') {
    name = 'rzTokenYw'
  } else {
    name = 'rzTokenTestYw'
  }
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    // 判断cookie的名称是否是需要获取的cookie名字
    let key = name + '='
    if (cookie.startsWith(key)) {
      const cookieValue = cookie.split('=')[1];
      // 执行你的逻辑
      return decodeURIComponent(cookieValue);
    }
  }
}

export function removeCookie(both = 'all') {
  let str = window.location.host.split('.')[0] + '.'
  let domain = window.location.host.replace(str, '')
  console.log('domain', domain);
  let yw = ''
  let dl = ''
  let evnName = process.env.VUE_APP_ENV_NAME
  if (evnName === 'pro') {
    yw = 'rzTokenYw'
    dl = 'rzTokenDl'
  } else {
    yw = 'rzTokenTestYw'
    dl = 'rzTokenTestDl'
  }
  if (evnName === 'dev') {
    if (both === 'all') {
      document.cookie = `${encodeURIComponent(yw)}=${encodeURIComponent(null)};path=/`;
      document.cookie = `${encodeURIComponent(dl)}=${encodeURIComponent(null)};path=/`;
    } else if (both === 'yw') {
      document.cookie = `${encodeURIComponent(yw)}=${encodeURIComponent(null)};path=/`;
    } else if (both === 'dl') {
      document.cookie = `${encodeURIComponent(dl)}=${encodeURIComponent(null)};path=/`;
    }
  }else {
    if (both === 'all') {
      document.cookie = `${encodeURIComponent(yw)}=${encodeURIComponent(null)};domain=${domain};path=/`;
      document.cookie = `${encodeURIComponent(dl)}=${encodeURIComponent(null)};domain=${domain};path=/`;
    } else if (both === 'yw') {
      document.cookie = `${encodeURIComponent(yw)}=${encodeURIComponent(null)};domain=${domain};path=/`;
    } else if (both === 'dl') {
      document.cookie = `${encodeURIComponent(dl)}=${encodeURIComponent(null)};domain=${domain};path=/`;
    }
  }
}
